import ClassNames from "classnames";
import { FunctionComponent, ReactNode } from "react";
import styles from "../stylesheets/components/editor-ui-toolbar.module.css";

interface Props {
  className?: string;
  children: ReactNode;
}

const EditorUIToolbar: FunctionComponent<Props> = ({ className, children }) => {
  return (
    <div className={ClassNames(styles.EditorUIToolbar, className)}>
      {children}
    </div>
  );
};

export default EditorUIToolbar;
